let getWindowInnerHeight = window.innerHeight,
    policySectionPt = 20,
    elemPolicyContainer = $('.policy-container'),
    elemPolicySidebar = $('.policy-sidebar'),
    elemPolicyDetail = $('.policy-detail'),
    elemPolicyContainerMt = parseFloat(elemPolicyContainer.css('margin-top')),
    elemPolicySidebarWidth = elemPolicySidebar.outerWidth() + parseFloat(elemPolicySidebar.css('margin-right')),
    elemPolicySidebarHeight = elemPolicySidebar.outerHeight(),
    elemPolicySidebarOffsetTop = elemPolicySidebar.offset().top,
    elemPolicySidebarTotalHeight = parseFloat(elemPolicySidebarOffsetTop + elemPolicySidebarHeight),
    isElemPolicySidebarFixed = false;

function setElemPolicySidebarFixed() {
    if ((getWindowInnerHeight + window.scrollY >= elemPolicySidebarTotalHeight) && !isElemPolicySidebarFixed) {
        sElemPolicySidebarFixed = true;
        elemPolicyDetail.css({
            'margin-left': elemPolicySidebarWidth
        });
        elemPolicySidebar.css({
            'height': 'auto',
            'position': 'fixed'
        });

        if (elemPolicySidebarHeight + elemPolicyContainerMt >= getWindowInnerHeight) {
            elemPolicySidebar.css({
                'top': 'unset',
                'bottom': 0
            });
        } else {
            elemPolicySidebar.css({
                'top': elemPolicyContainerMt + policySectionPt,
                'bottom': 'unset'
            });
        }
    }
}

function resetElemPolicySidebarFixed() {
    isElemPolicySidebarFixed = false;
    elemPolicyDetail.css({
        'margin-left': ''
    });
    elemPolicySidebar.css({
        'height': '',
        'position': '',
        'bottom': '',
        'top': ''
    });
}

function isScollToBottom() {
    return (window.scrollY >= elemPolicyContainerMt) ? true : false;
}

$(function() {
    $('.policy-sidebar--link').on('click', function() {
        let targetId = $(this).attr('href');
        $('.policy-sidebar--link').removeClass("active");
        $(this).addClass("active");
        $('html, body').animate({
            scrollTop: parseFloat($(targetId).offset().top - elemPolicyContainerMt - parseInt(policySectionPt))
        }, 600);
    });
    isScollToBottom() ? setElemPolicySidebarFixed() : null;
});

addEventListener("scroll", function() {
    isScollToBottom() ? setElemPolicySidebarFixed() : resetElemPolicySidebarFixed();
}, true);